import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { communityItemsData } from './MainLayout';
import PageHeader from './common/PageHeader';

function CommunityHub() {
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            <PageHeader icon={Globe} title="커뮤니티" />
            <div style={styles.grid}>
                {communityItemsData.map(item => {
                    const Icon = item.icon;
                    return (
                        <button key={item.path} onClick={() => navigate(item.path)} style={styles.card}>
                            <div style={styles.iconBox}>
                                <Icon size={24} color="#6366f1" />
                            </div>
                            <div style={styles.cardContent}>
                                <span style={styles.cardName}>{item.name}</span>
                                <span style={styles.cardDesc}>{item.desc}</span>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

const styles = {
    container: { padding: '24px', maxWidth: 960, margin: '0 auto' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginTop: 20 },
    card: {
        display: 'flex', alignItems: 'center', gap: 14,
        padding: '18px 16px', backgroundColor: '#fff', border: '1px solid #e2e8f0',
        borderRadius: 12, cursor: 'pointer', textAlign: 'left',
        transition: 'all 0.15s',
    },
    iconBox: {
        width: 48, height: 48, backgroundColor: '#eef2ff', borderRadius: 12,
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    },
    cardContent: { display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 },
    cardName: { fontSize: 14, fontWeight: 600, color: '#0f172a' },
    cardDesc: { fontSize: 12, color: '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
};

export default CommunityHub;
